module.exports = __webpack_public_path__ + "static/img/003.29d2b884.png";